import React, { useState } from 'react';
import { Dialog } from './Dialog';
import { CorporateTrainingForm } from '../Payment/CorporateTrainingForm';
import { PaystackScript } from '../Payment/PaystackScript';
import { Check } from 'lucide-react';
import { Button } from './Button';
interface CorporateTrainingDialogProps {
  isOpen: boolean;
  onClose: () => void;
}
export const CorporateTrainingDialog = ({
  isOpen,
  onClose
}: CorporateTrainingDialogProps) => {
  const [trainingStatus, setTrainingStatus] = useState<'pending' | 'success'>('pending');
  const [reference, setReference] = useState('');
  const handleSuccess = (reference: string) => {
    setReference(reference);
    setTrainingStatus('success');
  };
  const handleClose = () => {
    if (trainingStatus === 'success') {
      setTimeout(() => {
        setTrainingStatus('pending');
        setReference('');
      }, 300);
    }
    onClose();
  };
  return <>
      <PaystackScript data-id="element-1373" data-mp="1j94r80f9d90r" />
      <Dialog isOpen={isOpen} onClose={handleClose} title={trainingStatus === 'success' ? 'Training Request Successful' : 'Corporate Training Request'} size="md" data-id="element-1374" data-mp="1j8lbmqd2ywpw">
        <div className="p-4" data-id="element-1375" data-mp="37dmy2jv1jq0n">
          {trainingStatus === 'pending' ? <CorporateTrainingForm onSuccess={handleSuccess} data-id="element-1376" data-mp="37b0hxvu3426t" /> : <div className="text-center py-6" data-id="element-1377" data-mp="2tex0z4881qca">
              <div className="mx-auto w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4" data-id="element-1378" data-mp="2xf766eo6wcq3">
                <Check size={32} className="text-gray-700" data-id="element-1379" data-mp="3l51j0w8ie1ac" />
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-1380" data-mp="3l747vcxxdodh">
                Training Request Confirmed
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-1381" data-mp="3cczlb5ptqz3r">
                Thank you for requesting corporate training with The Networking
                Salon!
              </p>
              <p className="text-sm text-gray-500 mb-6" data-id="element-1382" data-mp="3gbox4tv7s8la">
                Reference: {reference}
              </p>
              <p className="text-gray-600 mb-6" data-id="element-1383" data-mp="copwwu5mkz8p">
                Our team will reach out to you within 24 hours to finalize the
                training schedule and logistics.
              </p>
              <Button className="w-full" onClick={handleClose} data-id="element-1384" data-mp="ijd5bobp78hh">
                Close
              </Button>
            </div>}
        </div>
      </Dialog>
    </>;
};